import Loadable from "app/components/Loadable";
import { lazy } from "react";
import { PERMISSIONS } from "app/utils/permissions";

const FishFarmVisitList = Loadable(lazy(() => import("./FishFarmVisitList")));
const FishFarmVisitForm = Loadable(lazy(() => import("./FishFarmVisitForm")));

const fishFarmVisitRoutes = [
  {
    path: "/FishFarmVisit/FishFarmVisitList",
    element: <FishFarmVisitList />,
    permission: PERMISSIONS.FishFarmVisits.Menu,
  },
  {
    path: "/FishFarmVisit/FishFarmVisitForm",
    element: <FishFarmVisitForm />,
  },
  {
    path: "/FishFarmVisit/FishFarmVisitForm/:fishFarmVisitId",
    element: <FishFarmVisitForm />,
  },
];

export default fishFarmVisitRoutes;
